import { render } from "./Aula.vue?vue&type=template&id=9962c876&scoped=true"
import script from "./Aula.vue?vue&type=script&lang=ts"
export * from "./Aula.vue?vue&type=script&lang=ts"

import "./Aula.vue?vue&type=style&index=0&id=9962c876&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9962c876"

export default script